import i18n from 'modules/core/lib/i18n'

export interface DemoTourTask {
  taskKey: string
  title: string
  description: string | null
}

interface DemoTourCategory {
  categoryKey: string
  title: string
  tasks: DemoTourTask[]
}

const STORAGE_KEY = 'demo_tour_state'

export const TASK_ORDER = ['filter_important', 'detect_alerts', 'bulk_approve'] as const

interface DemoTourState {
  completed: string[]
}

function readState(): DemoTourState {
  try {
    const raw = localStorage.getItem(STORAGE_KEY)
    if (!raw) return { completed: [] }
    const parsed: unknown = JSON.parse(raw)
    if (typeof parsed !== 'object' || parsed === null || !('completed' in parsed))
      return { completed: [] }
    const completed = Array.isArray(parsed.completed)
      ? parsed.completed.filter((item): item is string => typeof item === 'string')
      : []
    return { completed }
  } catch {
    return { completed: [] }
  }
}

function writeState(state: DemoTourState): void {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(state))
  } catch {}
}

export function getCompletedTasks(): string[] {
  return readState().completed
}

export function markTaskCompleted(taskKey: string): void {
  const state = readState()
  if (!state.completed.includes(taskKey)) {
    state.completed.push(taskKey)
    writeState(state)
  }
}

export function resetState(): void {
  writeState({ completed: [] })
}

export function getHardcodedTasks(): DemoTourCategory[] {
  return [
    {
      categoryKey: 'time_tracking',
      title: i18n.t('growth.get_started.demo_tour.category_time_tracking'),
      tasks: [
        {
          taskKey: 'filter_important',
          title: i18n.t('growth.get_started.demo_tour.task_filter_important'),
          description: null,
        },
        {
          taskKey: 'detect_alerts',
          title: i18n.t('growth.get_started.demo_tour.task_detect_alerts'),
          description: null,
        },
        {
          taskKey: 'bulk_approve',
          title: i18n.t('growth.get_started.demo_tour.task_bulk_approve'),
          description: null,
        },
      ],
    },
  ]
}

export function useDemoTourTasks() {
  const categories = getHardcodedTasks()
  const tasks = categories.flatMap((c) => c.tasks)
  return { categories, tasks }
}
